import apiClient from './client';

// ─── Typen ──────────────────────────────────────────────────────────────────

export interface LifelineMilestone {
  year: number;
  type: 'marriage' | 'child_birth';
  label: string;
}

export interface LifelinePerson {
  id: string;
  firstName: string;
  lastName: string | null;
  gender: string | null;
  birthYear: number | null;
  deathYear: number | null;
  isLiving: boolean;
  /** Rechtes Balkenende: Tod, bei plausibel Lebenden heute, sonst letztes bekanntes Ereignis. */
  endYear: number | null;
  /** Kein Sterbedatum und nicht plausibel lebend → Linie läuft nicht bis heute. */
  fateUnknown: boolean;
  milestones: LifelineMilestone[];
}

export interface LifelinesData {
  persons: LifelinePerson[];
  yearMin: number;
  yearMax: number;
}

// ─── API-Funktion ────────────────────────────────────────────────────────────

export async function fetchLifelines(): Promise<LifelinesData> {
  const { data } = await apiClient.get<LifelinesData>('/lifelines');
  return data;
}
